module.exports = __webpack_public_path__ + "static/img/06.3cd790e4.png";